const MatchCustomButtonOperator = (props) => {  
  const { data  } = props;  
  const { onEdit, onJodiReport } = props.context;

//   const parseDDMMYYYY = (dateStr) => {
//   const [day, month, year] = dateStr.split("-");
//   return new Date(`${year}-${month}-${day}T00:00:00`);
// };

  return (
    <div className="flex h-full w-full flex-wrap items-center gap-1">
      {onJodiReport && (
        <button
          className="bg-indigo-500 text-white px-1.5 py-0.5 rounded text-[11px] leading-tight whitespace-nowrap"
          onClick={() => onJodiReport(data.id)}
        >
          Jodi Report
        </button>
      )}
      <button
        className="bg-blue-500 text-white px-1.5 py-0.5 rounded text-[11px] leading-tight whitespace-nowrap"
        onClick={() => onEdit(data.id)}
      >
        Edit
      </button>
      {/* <button
        className="bg-red-500 text-white px-2 py-1 rounded text-xs"
        onClick={() => onDelete(data.id)}
      >
        Delete
      </button>
     {isMatch && data.statusen==='active' && ( 
        <button
          className="bg-yellow-500 text-white px-2 py-1 rounded text-xs"
          onClick={() => onAbandon(data.id)}
        >
          Abandon
        </button>
      )} */}
    </div>
  );
};
export default MatchCustomButtonOperator;
